import React, { useCallback } from 'react'
import DocumentationLists from '../../application-coo/documents/documentation-list'
import { P2TextDescription } from 'react-bootstrap-common-script'
import { DocumentItem, FileItem } from '../../../models/polymer/Document.model';
import { StageBDocumentation } from '../../../models/classes/stage-b/review-endorse.class';
import { usePrepareDocuments } from '../../../hooks/use-prepare-documents';

interface ReviewConveyancingDocumentProps{
  SetDocumentationValue: React.Dispatch<React.SetStateAction<StageBDocumentation>>;
  documentation_values: StageBDocumentation;
  required_document_list: DocumentItem[]
  getAdditionalCheckbox: (additionalCheckbox: string[]) => void;
  forceError?: boolean;
}
function ReviewConveyancingDocument({...props}:ReviewConveyancingDocumentProps) {
  
  const setDocumentValue = useCallback((file_items:FileItem[])=>{
    props.SetDocumentationValue({file_items:file_items});
  },[props])

  return (
    <div className='px-4 py-4'>
      <P2TextDescription color='#000' title='Upload Documents' />
      <div className='mt-4 d-flex flex-column gap-3'>
        <DocumentationLists forceError={props.forceError} folderName="Letter of Lawyer's Representation" type={3} document_list={props.required_document_list} setFileItemsStorage={setDocumentValue} filesItemsStorage={props.documentation_values.file_items} getAdditionalCheckbox={props.getAdditionalCheckbox} />
      </div>
    </div>
  )
}

export default ReviewConveyancingDocument